import { ComposeViewState } from 'owa-mail-compose-store';
import { action } from 'satcheljs/lib/legacy';

export default action('updateSubjectSelectionRange')(function updateSubjectSelectionRange(
    viewState: ComposeViewState,
    start: number,
    end: number
) {
    viewState.subjectViewState.selectionStart = start;
    viewState.subjectViewState.selectionEnd = end;
});
